import useRoverBrandContext from '@rover/react-lib/src/context/useRoverBrandContext';
import { PetType } from '@rover/types/src/Pet';
import { RoverBrand, RoverBrandPetType } from '@rover/types/src/RoverBrand';

const useBrandSpecificPets = (): PetType[] => {
  const { brand } = useRoverBrandContext();

  return RoverBrandPetType[brand] ?? RoverBrandPetType[RoverBrand.Rover];
};

export default useBrandSpecificPets;
